import { observer } from 'mobx-react';
import React, { useCallback, useState } from 'react';

import { KeyboardArrowDownOutlined } from '@mui/icons-material';
import { MenuItem, Paper, Select, Typography } from '@mui/material';

import useStores from 'hooks/use-stores';

import CVELineChart from './CVELineChart';
import useStyles from './styles';

interface Props {
    className?: string;
}

const Progression: React.FC<Props> = ({ className }) => {
    const { classes, cx } = useStyles();
    const [name, setName] = useState('type');
    const [value, setValue] = useState('cve');

    const { statsStore } = useStores();

    const handleTypeNameChange = useCallback((event) => {
        setName(event.target.value);
        setValue(event.target.value === 'type' ? 'cve' : 'unix');
    }, []);

    const handleTypeValueChange = useCallback((event) => setValue(event.target.value), []);

    const getTermValueItems = () => {
        const { types } = statsStore;
        const names = Object.keys(types);

        const bulletinTypeFamilies = [...new Set(names.map((os) => types[os].bulletinFamily))];

        const collection = name === 'type' ? names : bulletinTypeFamilies;
        return collection.map((term) => (
            <MenuItem key={term} value={term} className={classes.menuItem}>
                {term}
            </MenuItem>
        ));
    };

    return (
        <Paper elevation={0} className={cx(classes.root, className)}>
            <Typography variant="h4" className={classes.title}>
                {'Vulnerabilities progression'}
            </Typography>

            <p className={classes.description}>
                {'Visualization of security advisories appearance in recent years divided by types and families'}
            </p>

            <div className="vulners-chart-select-tools">
                <Select
                    variant="outlined"
                    IconComponent={KeyboardArrowDownOutlined}
                    value={name}
                    onChange={handleTypeNameChange}
                    className={classes.select}
                >
                    <MenuItem value="type">{'Type'}</MenuItem>
                    <MenuItem value="bulletinFamily">{'Family'}</MenuItem>
                </Select>

                <Select
                    variant="outlined"
                    IconComponent={KeyboardArrowDownOutlined}
                    value={value}
                    onChange={handleTypeValueChange}
                    className={classes.select}
                >
                    {getTermValueItems() || <MenuItem value={value}>{'Select Type'}</MenuItem>}
                </Select>
            </div>

            <div className={classes.chart}>
                <CVELineChart termName={name} termValue={value} />
            </div>
        </Paper>
    );
};

export default observer(Progression);
